import {ID as PROMO_BTN_ID, renderPromoButton} from "../react-components/promo/buttons/general.jsx";
import {addOrRemoveClass} from "../utils.js";
import {ID as CUSTOMER_RATING_BAR_ID, renderCustomerRatingBar} from "../react-components/customer-rating-bar";
import {hidePopover} from "../popovers/popovers.js";

const PARENT_CLASS = "parent";
const DEEP_LEVEL_ATTRIBUTE = "deepnessLevel";

const COLLAPSIBLE_LIST_CONTENT_CLASS = ".products-collapsible-list-content";
const popover = `${COLLAPSIBLE_LIST_CONTENT_CLASS} [rel="popover-clickable"]`;

document.addEventListener('DOMContentLoaded', () => {
  $(document).on('click', function (e) {
    $(popover).each(() => hidePopover(e));
  });

  window.handleToggleList = function (event, parentProductID, parentProductSlug, parentProductClassname, nextClassname, retailerID, storeID) {
    const target = `${parentProductSlug}-collapse`;
    const parentItem = event.target.closest(`#${parentProductSlug}-product-item`);
    const btnContainer = document.getElementById(`${parentProductSlug}-btn-container`);
    const btn = document.getElementById(`${parentProductSlug}-btn`);
    const collapsibleList = document.getElementById(`${parentProductSlug}-collapse`);
    const listContent = document.getElementById(`${parentProductSlug}-collapsible-list-content`);
    const loaderContainer = document.getElementById(`${parentProductSlug}-loader-container`)
    const loader = document.getElementById(`${parentProductSlug}-loader`);

    $(`#${target}`).collapse('toggle');

    $(`#${target}`).on('shown.bs.collapse', function (e) {
      if (e.target.id === target) {

        let productListContent;

        addOrRemoveClass(parentItem, 'active', true);
        addOrRemoveClass(parentItem, 'parent-opening', true);
        addOrRemoveClass(btnContainer, 'active', true);
        addOrRemoveClass(btnContainer, 'opening', true);
        addOrRemoveClass(btn, "collapsed", false);
        addOrRemoveClass(collapsibleList, 'loading', true);

        // If there is product list content already, do not show the loading spinner again
        if (!productListContent) {
          addOrRemoveClass(loader, 'spinner-border', true);
          addOrRemoveClass(loaderContainer, 'spinner-container-active', true)
        }

        const baseURL = `/api/v2/${nextClassname}/collapsible/?parent=${parentProductID}&parent_class=${parentProductClassname}&`;
        let url = '';

        if (retailerID) url = `${baseURL}&retailer=${retailerID}`;
        else if (storeID) url = `${baseURL}&store=${storeID}`;
        else url = baseURL;

        $.get(url)
          .done((result) => {

            addOrRemoveClass(loader, 'spinner-border', false);
            addOrRemoveClass(loaderContainer, 'spinner-container-active', false)

            if (result.collapsible_items) {
              const data = result.collapsible_items;

              addOrRemoveClass(parentItem, 'parent-opening', false);
              addOrRemoveClass(collapsibleList, 'loading', false);
              addOrRemoveClass(btnContainer, 'opening', false);

              if (listContent) {
                productListContent = data.map((item) => item.content).join(" ");
                listContent.innerHTML = productListContent;

                const parentDeepLevel = parentItem.dataset[DEEP_LEVEL_ATTRIBUTE];
                const parentChildren = document.querySelectorAll(`#${parentProductSlug}-product-item .product-item`)
                const parentChildrenArray = [...parentChildren];

                // Add deep level to each product item
                parentChildrenArray.forEach((item) => {
                  item.dataset[DEEP_LEVEL_ATTRIBUTE] = Number(parentDeepLevel) + 1;
                });
              }

              renderPromoButton(`${COLLAPSIBLE_LIST_CONTENT_CLASS} #${PROMO_BTN_ID}`);
              renderCustomerRatingBar(`${COLLAPSIBLE_LIST_CONTENT_CLASS} #${CUSTOMER_RATING_BAR_ID}`);

              window.initializePopovers();
              window.initializeMatchDataCollapsible(null, `#${parentProductSlug}-product-item`);

              $('.match-data-modal').on('shown.bs.modal', function() {
                window.initializeMatchDataTitlesAdjustments();
              })
            }
          })

        if (!collapsibleList.classList.contains(PARENT_CLASS)) {
          addOrRemoveClass(collapsibleList, PARENT_CLASS, true);
        }
      }
    });

    $(`#${target}`).on('hidden.bs.collapse', function (e) {
      if (e.target.id === target) {

        addOrRemoveClass(loader, 'spinner-border', false);
        addOrRemoveClass(loaderContainer, 'spinner-container-active', false)

        addOrRemoveClass(parentItem, 'active', false);
        addOrRemoveClass(btnContainer, 'active', false);
        addOrRemoveClass(btn, "collapsed", true);
        // Don't remove this or onclick will trigger multiple times.
        btn.removeEventListener('click', handleToggleList);

        listContent.innerHTML = "";
      }
    });
  }
});
